import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as BinIcon } from '../../../../assets/images/bin.svg';
import { ReactComponent as EditIcon } from '../../../../assets/images/pencil.svg';
// import { ReactComponent as ReferIcon } from '../../../../assets/images/Refer.svg';
import Pagination from '../../../../components/Pagination/Pagination';
import Menu from '../../../../components/shared/Menu/Menu';

import styles from './ContactsList.module.scss';

export const ContactsList = ({ contacts, setPage, pageInfo, setPerPage, handleOpenModal, toggleDeleteOption }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleViewRecommendations = (contactId) => {
    navigate(`/account/network/contact/${contactId}/recommendations`);
  };

  return (
    <div className={styles.rootCont}>
      {contacts.map((contact) => (
        <div className={styles.contactCont} key={contact.id}>
          <div>
            <p className={styles.name} onClick={() => handleOpenModal(contact)} role="presentation">
              {contact.full_name}
            </p>
            {contact.user_contact_emails_attributes.map((data) => (
              <p className={styles.email} key={data.email}>
                {data.email}
              </p>
            ))}
            <p className={styles.phone}>{contact.phone_number}</p>
            {contact.has_recommendations ? (
              <button
                type="button"
                className={styles.recommendationsBtn}
                onClick={() => handleViewRecommendations(contact.id)}
              >
                {t('view')}
              </button>
            ) : (
              <span className={styles.noRecommendations}>{t('none')}</span>
            )}
          </div>
          <Menu
            items={[
              // {
              //   title: t('refer'),
              //   action: () => {},
              //   icon: ReferIcon,
              //   isColorPrimary: true,
              // },
              {
                title: t('edit'),
                action: () => handleOpenModal(contact),
                icon: EditIcon,
              },
              {
                title: t('delete'),
                action: () => toggleDeleteOption(contact),
                icon: BinIcon,
              },
            ]}
          />
        </div>
      ))}
      <Pagination setPage={setPage} pageInfo={pageInfo} setPerPage={setPerPage} />
    </div>
  );
};
